<template>
  <v-card
    class="mx-2 mx-sm-auto mb-4 pa-4"
    max-width="600"
  >
    <div class="d-flex">
      <v-switch
        v-model="local.isEncryptDoc"
        hide-details
        class="mt-1 mr-2"
        :readonly="!local.myPublicKey"
        @click="onSwitchClick"
      >
        <template v-slot:label>
          <span class="mr-2">{{ $t('encrypt.isEncryptedDoc') }}</span>
          <v-icon
            v-if="local.isEncryptDoc"
            color="primary"
          >
            {{ mdiLockOutline }}
          </v-icon>
          <v-icon v-else>
            {{ mdiLockOffOutline }}
          </v-icon>
        </template>
      </v-switch>

      <v-spacer />
      <v-btn
        icon
        @click="dialog = true"
      >
        <v-icon>{{ mdiHelpCircleOutline }}</v-icon>
      </v-btn>
    </div>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title>
          {{ $t('PublicServant.Reminds') }}
        </v-card-title>

        <v-card-text>
          <ul>
            <!--
              <li>{{ $t('encrypt.notice.content1') }}</li>
            -->
            <li class="red--text">
              {{ $t('encrypt.notice.content2') }}
            </li>
          </ul>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialog = false"
          >
            {{ $t('PublicServant.Action.Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="local.isEncryptDoc">
      <v-radio-group
        v-model="local.securityLevel"
        row
      >
        <v-radio
          :label="$t('encrypt.level.a')"
          :value="SECURITY_LEVEL.SECRET"
        />
        <!-- 秘密 -->
        <v-radio
          :label="$t('encrypt.level.b')"
          :value="SECURITY_LEVEL.CONFIDENTIAL"
        />
        <!-- 機密 -->
        <!--
        <v-radio
          :label="$t('encrypt.level.c')"
          :value="SECURITY_LEVEL.TOP_CONFIDENTIAL"
        />
        -->
        <!-- 機密(最高負債人親啟) -->
      </v-radio-group>
    </div>
  </v-card>
  <!-- <v-card
    v-else
    class="mx-2 mx-sm-auto mb-4 pa-4"
    max-width="600"
  >
    {{ $t("outbox.encrypt.noKeyCannotProcess") }}
  </v-card> -->
</template>

<script>

import { mdiLockOutline, mdiLockOffOutline, mdiHelpCircleOutline } from '@mdi/js'
import { SECURITY_LEVEL } from '@/constant/constant'
import { globalModule } from '@/store/moduleName'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      mdiLockOutline,
      mdiLockOffOutline,
      mdiHelpCircleOutline,
      dialog: false,
      SECURITY_LEVEL
    }
  },
  computed: {
    local () {
      return this.value
    }
  },
  methods: {
    onSwitchClick () {
      if (!this.local.myPublicKey) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('outbox.encrypt.noKeyCannotProcess'))
      }
    }
  }
}
</script>
